import type {RuleValidationErrors} from '../types';
import type {CategoryIdRule} from './types';
import {createValidationObject} from '../../utils/createValidationObject';

export const validateCatrgoryIdRule = <
	T extends CategoryIdRule = CategoryIdRule,
>(
	rule: T,
): RuleValidationErrors | false => {
	if (typeof rule.elementValue1 !== 'number' || rule.elementValue1 < 1) {
		return {
			elementValue1: createValidationObject(),
		};
	}
	return false;
};

export default validateCatrgoryIdRule;
